angular
  .module('tgaApp')
  .factory(
    'TTAGameData', ['$window',
      function ($window) {
        // function TTAGameData() {
        // }

        // ---
        // STATIC METHODS.
        // ---
        // TTAGameData.method = function () {
        //   return;
        // };

        // ---
        // INSTANCE METHODS.
        // ---
        // TTAGameData.prototype = {
        //   // Best practice for "instnceof" operator.
        //   constructor: TTAGameData,
        //   ...$window.TTAGameData,
        //   // ---
        //   // PUBLIC METHODS.
        //   // ---
        //   // method: () => {}
        // };
        // Return the factory instance.
        return ($window.TTAGameData.Scenarios);
      },
    ],
  );
